<script>
import Banner from '../components/banner'
export default {
    name: "partnership",
    data() {
        return {};
    },
    computed: {},
    components: {
        Banner
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="partnership">
        <Banner position="center left" :image="require('@/assets/images/partnership_banner.jpg')" :title="`Partnership Represented`" :desc="`We collaborate with leading British universities and\r\nprofessional awarding bodies to bring the best education to you.`"/>
        <div class="wrapper layout_main flex flex_column">
            <div class="content">
                <div class="flex align_start">
                    <img data-type="pc" src="@/assets/images/partnership_01.jpg" alt=""/>
                    <div class="text">
                        <p class="title">Anglia Ruskin University</p>
                        <p>Anglia Ruskin University (ARU) is a public university in East Anglia, United Kingdom. It became a university in 1992 and currently has over 40,000 students worldwide with campuses in Cambridge, Chelmsford, Peterborough and London.</p>
                        <p>ARU has been named one of the top 350 institutions in the world in the Times Higher Education World University Rankings 2021, for the fifth successive year – and one of the top 40 universities in the UK. ARU also listed in the top 10 for social inclusion in The Times Good University Guide 2021. Anglia Ruskin University was also the only UK university to be named a global ‘rising star‘ by Times Higher Education.</p>
                        <p>Anglia Ruskin University ranked in the top 20 universities for teaching excellence in The Times and The Sunday Times Good University Guide for 2017, with six subjects in the top 10 UK higher education institutions for teaching excellence. As well as this, the Teaching Excellence Framework (TEF) Silver award recognises the quality of courses and high levels of student satisfaction.</p>
                    </div>
                </div>
            </div>
            <div class="content">
                <!--  -->
                <p class="title" data-type="pc">University of Central Lancashire</p>
                <div class="flex align_start" data-type="pc">
                    <div class="text">
                        <p>The University of Central Lancashire (UCLan) is a public research university located in Preston, Lancashire, England. It was founded in 1828 and has since established itself as a leading educational institution, providing students with exceptional learning experiences and a supportive community. With over 190 years of academic excellence, UCLan has grown to become one of the largest universities in the UK, serving over 30,000 students from around the world.</p>
                        <p><br/></p>
                        <p>Rankings and awards:</p>
                        <p class="li">Ranked in the top 3.3% of universities worldwide by the Center for World University Rankings</p>
                        <p class="li">Named one of the top 10 universities in the UK for student support by the Times Higher Education Student Experience Survey</p>
                        <p class="li">Winner of the University of the Year award at the 2020 Educate North Awards</p>
                        <p class="li">Named Best International University at the 2020 WhatUni Student Choice Awards</p>
                        <p class="li">Recognized as a Centre for Excellence in Cyber Security Research by the UK Government’s National Cyber Security Centre</p>
                    </div>
                    <img src="@/assets/images/partnership_02.jpg" alt=""/>
                </div>
                <div class="flex align_start" data-type="mobile">
                    <div class="text">
                        <p class="title">University of Central Lancashire</p>
                        <p>The University of Central Lancashire (UCLan) is a public research university located in Preston, Lancashire, England. It was founded in 1828 and has since established itself as a leading educational institution, providing students with exceptional learning experiences and a supportive community. With over 190 years of academic excellence, UCLan has grown to become one of the largest universities in the UK, serving over 30,000 students from around the world.</p>
                    </div>
                    <img class="type2" src="@/assets/images/partnership_02_mobile.jpg" alt=""/>
                </div>
                <div class="flex align_start" data-type="mobile">
                    <div class="text">
                        <p>Rankings and awards:</p>
                        <p class="li">Ranked in the top 3.3% of universities worldwide by the Center for World University Rankings</p>
                        <p class="li">Named one of the top 10 universities in the UK for student support by the Times Higher Education Student Experience Survey</p>
                        <p class="li">Winner of the University of the Year award at the 2020 Educate North Awards</p>
                        <p class="li">Named Best International University at the 2020 WhatUni Student Choice Awards</p>
                        <p class="li">Recognized as a Centre for Excellence in Cyber Security Research by the UK Government’s National Cyber Security Centre</p>
                    </div>
                </div>
                <!--  -->
                <!--  -->
                <div class="flex align_start" data-type="pc">
                    <div class="text">
                        <p>UCLan is committed to providing flexible and accessible education, with a range of distance learning facilities available. Students can choose to study online or through a blended learning approach, allowing them to fit their studies around their work and personal commitments. The university’s online platform provides access to a range of resources, including video lectures, online discussion forums, and interactive assessments, ensuring that students receive the same high-quality education as their on-campus peers. Overall, studying at UCLan offers students the opportunity to receive a world-class education, access to top-ranked programs and support services, and a flexible and accessible learning environment.</p>
                    </div>
                    <img src="@/assets/images/partnership_03.jpg" alt=""/>
                </div>
                <div class="flex align_start" data-type="mobile">
                    <div class="text">
                        <p>UCLan is committed to providing flexible and accessible education, with a range of distance learning facilities available. Students can choose to study online or through a blended learning approach, allowing them to fit their studies around their work and personal commitments. The university’s online platform provides access to a range of resources, including video lectures, online discussion forums, and interactive assessments, ensuring that students receive the same high-quality education as their on-campus peers. Overall, studying at UCLan offers students the opportunity to receive a world-class education, access to top-ranked programs and support services, and a flexible and accessible learning environment.</p>
                    </div>
                </div>
                <div class="flex align_start" data-type="mobile">
                    <img src="@/assets/images/partnership_03_mobile.jpg" alt=""/>
                </div>
                <!--  -->
            </div>
            <div class="content">
                <p class="title">School of business and<br data-type="mobile"/> technology London</p>
                <div class="flex align_start">
                    <img data-type="pc" src="@/assets/images/partnership_04.jpg" alt=""/>
                    <div class="text">
                        <p>School of Business and Technology London is dedicated to offering higher and professional courses to learners worldwide through online and blended learning.</p>
                        <p>We are committed to providing high-quality education to transform your skills, knowledge, and understanding, enhance your employability, and enable you to compete successfully in the dynamic and ever-changing business world.</p>
                        <p>We empower your career aspirations by providing a structured, interactive, supportive learning experience through online and blended certification courses. Our courses are designed to cater to the varied needs of learners at different points in their work lives.</p>
                        <p>Whether you are a beginner or a working professional seeking further development, we are here to guide you at every turn.</p>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="flex align_start" data-type="mobile">
                    <img src="@/assets/images/partnership_05_mobile.jpg" alt=""/>
                </div>
                <div class="flex align_start">
                    <div class="text">
                        <p class="title">Shanghai Yizhen<br data-type="pc"/> Immigration<br/>Consulting Ltd</p>
                        <p>Shanghai yizhen is a shanghai based education consulting company, providing professional help and advice to Clients with their further education in UK, Hong Kong and Australia, With over 10 years of experience, their professional services have been highly regarded by clients.</p>
                    </div>
                    <img data-type="pc" src="@/assets/images/partnership_05.jpg" alt=""/>
                </div>
            </div>
            <div class="content">
                <p class="title">Awarding Organizations</p>
                <div class="flex">
                    <img data-type="pc" src="@/assets/images/partnership_06.jpg" alt=""/>
                    <div class="text flex flex_column">
                        <p class="title2">Qualifi Ltd</p>
                        <p>Qualifi is a leading 21st century Awarding Organisation founded to meet the developing education and training needs of learners and employers from the UK and around the globe serving the needs of learners, employers and providers alike. We identified a growing demand for consistent and credible academic qualifications and awards as the economy became more competitive and global in nature – especially in many fast-paced industry sectors. They work with a growing number of sector skills councils, professional associations and employers to identify mission-critical learning requirements and assess outcomes of programmes to achieve a consistent and recognised professional and academic standards.</p>
                        <div class="flex_grow_1 flex align_center">
                            <img src="@/assets/images/partnership_logo_qualifi.jpg" alt="" class="logo"/>
                        </div>
                    </div>
                </div>
                <div class="flex align_start" data-type="mobile">
                    <img src="@/assets/images/partnership_07_mobile.jpg" alt=""/>
                </div>
                <div class="flex">
                    <img data-type="pc" src="@/assets/images/partnership_07.jpg" alt=""/>
                    <div class="text flex flex_column">
                        <p class="title2">OTHM</p>
                        <p>OTHM is a UK based Awarding Organisation regulated by Ofqual (Office of the Qualifications and Examinations Regulation). </p>
                        <p>OTHM always aim to develop as an organisation that is forward-thinking in order to support professions and industry by providing excellent qualifications that contribute for a highly qualified and experienced workforce. </p>
                        <p>OTHM has established strong academic relationships in the UK and overseas to ensure that OTHM qualifications are recognised globally.The local and international recognition has enabled OTHM graduates to enhance their employability skills as well as allowing them to join degree and/or Master top-up programmes.</p>
                        <div class="flex_grow_1 flex align_center">
                            <img src="@/assets/images/partnership_logo_othm.jpg" alt="" class="logo"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding: .8rem 0;
    gap: .8rem 0;
    [data-type=pc]{
        @media only screen and (max-width: 750px) {
            display: none;
        }
    }
    [data-type=mobile]{
        display: none;
        @media only screen and (max-width: 750px) {
            display: block;
            &.flex{
                display: flex;
            }
        }
    }
}
.title{
    font-size: .44rem;
    font-weight: bold;
    margin-bottom: .3rem;
    line-height: 1.2;
    @media only screen and (max-width: 750px) {
        font-size: .32rem;
    }
}
.title2{
    font-size: .32rem;
    font-weight: 600;
    @media only screen and (max-width: 750px) {
        font-size: .28rem;
    }
}
.text{
    flex-grow: 1;
    font-size: .18rem;
    font-weight: normal;
    line-height: 1.7;
    text-align: justify;
    @media only screen and (max-width: 750px) {
        font-size: .24rem;
        line-height: 1.4;
    }
    .li{
        display: flex;
        &::before{
            content: "·";
            font-size: .24rem;
            color: var(--color-blue);
            margin-right: .1rem;
            line-height: 1.2;
        }
    }
}
.content{
    .flex{
        gap: 0 .3rem;
        margin-bottom: .4rem;
        &:last-child{
            margin-bottom: 0;
        }
        @media only screen and (max-width: 750px) {
            gap: 0 .2rem;
        }
    }
    img{
        width: 5.8rem;
        flex-shrink: 0;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        &.type2{
            width: 2.8rem;
        }
    }
    .logo{
        width: auto;
        height: .7rem;
        @media only screen and (max-width: 750px) {
            margin-top: .2rem;
        }
    }
}
</style>